import React, { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";
import styles from "./MGChip.module.css";

export type TMGChipBackground = "light" | "dark";
export type TMGChipSize = "sm" | "md";

export type TMGChipProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  label: string;
  background?: TMGChipBackground;
  selected?: boolean;
  size?: TMGChipSize;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  dataTestId?: string;
};

export const MGChip = forwardRef<HTMLButtonElement, TMGChipProps>(
  (
    {
      label,
      background = "light",
      selected = false,
      size = "sm",
      iconLeft,
      iconRight,
      dataTestId,
      disabled = false,
      type = "button",
      className,
      ...buttonProps
    },
    ref,
  ) => (
    <button
      {...buttonProps}
      ref={ref}
      type={type}
      disabled={disabled}
      aria-pressed={selected}
      className={`${styles.chip}${className ? ` ${className}` : ""}`}
      data-background={background}
      data-size={size}
      data-selected={selected}
      data-testid={dataTestId}>
      {iconLeft && (
        <span className={styles.iconLeft} aria-hidden="true">
          {iconLeft}
        </span>
      )}
      <span className={styles.label}>{label}</span>
      {iconRight && (
        <span className={styles.iconRight} aria-hidden="true">
          {iconRight}
        </span>
      )}
    </button>
  ),
);

MGChip.displayName = "MGChip";
